import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import { Button, Card, Col, Container, Row, Accordion, ButtonGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import heroImage from "../../assets/hero-image.webp"; 
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const [billingCycle, setBillingCycle] = useState('annual'); // 'annual' or 'monthly'

  const proPlanPrice = billingCycle === 'annual' ? '4,99€/mois' : '6,99€/mois';
  const proPlanBillingText = billingCycle === 'annual' ? '(facturé annuellement)' : '(facturé mensuellement)';


  return (
    <div className="landing-page-container">
      {/* Section Hero */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImage})`,
        }}
      >
        <Container className="text-center">
          <h1 className="hero-title">
            Estimez le coût de vos travaux de rénovation en quelques clics
          </h1>
          <p className="hero-subtitle">
            Grâce à l'intelligence artificielle, obtenez une estimation précise et trouvez les meilleurs artisans pour votre projet.
          </p>
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate("/signup")}
            className="cta-button"
          >
            Commencez votre estimation gratuite
          </Button>
        </Container>
      </section>

      {/* Section Comment ça marche ? */}
      <section className="how-it-works-section">
        <Container>
          <h2 className="section-title">Comment ça marche ?</h2>
          <Row className="text-center">
            <Col md={4} className="step-item">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="step-svg">
                    <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" stroke="#ff8c00" strokeWidth="2"/>
                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#ff8c00" strokeWidth="2"/>
                    <path d="M18 6L18 6" stroke="#ff8c00" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              <h3 className="step-title">1. Photographiez</h3>
              <p>Prenez des photos de la pièce ou du bien à rénover.</p>
            </Col>
            <Col md={4} className="step-item">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="step-svg">
                    <path d="M12 2L12 4" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M20 12L22 12" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M4 12L2 12" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M12 22L12 20" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M17.6569 6.34315L16.2426 7.75736" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M7.75736 16.2426L6.34315 17.6569" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M6.34315 6.34315L7.75736 7.75736" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M16.2426 16.2426L17.6569 17.6569" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M9 17.65V15.53C9 14.38 9.6 13.34 10.58 12.78L12 12L13.42 12.78C14.4 13.34 15 14.38 15 15.53V17.65C15 18.95 13.94 20 12.65 20H11.35C10.06 20 9 18.95 9 17.65Z" stroke="var(--accent-orange)" strokeWidth="2"/><path d="M12 12V7C12 5.34 10.66 4 9 4H8" stroke="var(--accent-orange)" strokeWidth="2"/><path d="M12 12V7C12 5.34 13.34 4 15 4H16" stroke="var(--accent-orange)" strokeWidth="2"/>
                </svg>
              <h3 className="step-title">2. Analysez</h3>
              <p>Notre IA analyse les images et les données pour chiffrer les travaux.</p>
            </Col>
            <Col md={4} className="step-item">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="step-svg">
                    <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2V8H20" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M16 13H8" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M16 17H8" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/><path d="M10 9H8" stroke="var(--accent-orange)" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              <h3 className="step-title">3. Estimez</h3>
              <p>Recevez une estimation détaillée du coût des matériaux et de la main-d'œuvre.</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section Présentation */}
      <section className="features-section">
        <Container>
          <h2 className="section-title">Pourquoi choisir Renovestim ?</h2>
          <Row>
            <Col md={4} className="text-center feature-item">
              <i
                className="fas fa-tools fa-3x"
                style={{ color: "#ff8c00" }}
              ></i>
              <h3 style={{ marginTop: "20px" }}>Analyse intelligente</h3>
              <p>
                Analysez vos biens pièce par pièce ou dans leur ensemble pour
                une gestion simplifiée.
              </p>
            </Col>
            <Col md={4} className="text-center feature-item">
              <i
                className="fas fa-chart-line fa-3x"
                style={{ color: "#ff8c00" }}
              ></i>
              <h3 style={{ marginTop: "20px" }}>Optimisation de projets</h3>
              <p>
                Profitez de données détaillées pour optimiser vos projets de
                rénovation.
              </p>
            </Col>
            <Col md={4} className="text-center feature-item">
              <i
                className="fas fa-users fa-3x"
                style={{ color: "#ff8c00" }}
              ></i>
              <h3 style={{ marginTop: "20px" }}>Annuaire d'artisans</h3>
              <p>
                Artisans, rejoignez notre annuaire pour être redirigé vers des
                utilisateurs ayant des projets à réaliser.
              </p>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => navigate("/inscription-artisan")}
              >
                En savoir plus
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      

      {/* Section Exemples d'estimations (anonymisés) */}
      <section className="examples-section">
        <Container>
          <h2 className="section-title">Exemples d’estimations (anonymisés)</h2>
          <Row>
            <Col md={4}>
              <Card className="testimonial-card">
                <Card.Body>
                  <Card.Title>T2 — Lyon — 48 m²</Card.Title>
                  <Card.Text>
                    Budget estimé: <strong>24 500 € HT</strong>
                    <br />12 postes identifiés
                    <br />Dossier PDF généré
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="testimonial-card">
                <Card.Body>
                  <Card.Title>Maison 1930 — Lille — 110 m²</Card.Title>
                  <Card.Text>
                    Budget estimé: <strong>38 700 € HT</strong>
                    <br />24 postes identifiés
                    <br />Rafraîchissement complet
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="testimonial-card">
                <Card.Body>
                  <Card.Title>Studio — Paris 18e — 22 m²</Card.Title>
                  <Card.Text>
                    Budget estimé: <strong>9 800 € HT</strong>
                    <br />7 postes identifiés
                    <br />Optimisation d’espace
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <p className="text-muted mt-3 small">
            Exemples anonymisés à titre indicatif. Les montants varient selon le bien, les matériaux et la localisation.
          </p>
        </Container>
      </section>

      {/* Section Prix */}
      <section className="pricing-section">
        <Container>
          <h2 className="section-title">Nos offres</h2>
          <Row className="justify-content-center mb-4">
            <Col xs="auto">
              <ButtonGroup>
                <Button
                  variant={billingCycle === 'annual' ? 'primary' : 'outline-primary'}
                  onClick={() => setBillingCycle('annual')}
                >
                  Annuel
                </Button>
                <Button
                  variant={billingCycle === 'monthly' ? 'primary' : 'outline-primary'}
                  onClick={() => setBillingCycle('monthly')}
                >
                  Mensuel
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Row>
            {/* Free */}
            <Col md={4}>
              <Card className="text-center h-100 d-flex flex-column pricing-card">
                <Card.Body className="d-flex flex-column">
                  <Card.Title>Essai</Card.Title>
                  <Card.Text className="flex-grow-1">
                    <strong>100 RC (10€) offerts</strong>
                    <br />
                    <br />
                    Analyse pièce : 10 RC
                    <br /> Analyse complète : 90 RC
                  </Card.Text>
                  <Button
                    variant="outline-primary"
                    onClick={() => navigate("/signup")}
                  >
                    Commencer gratuitement
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            {/* Pro */}
            <Col md={4}>
              <Card className="text-center h-100 d-flex flex-column pricing-card pricing-card-pro">
                <Card.Header as="h5" className="pro-header">Le plus populaire</Card.Header>
                <Card.Body className="d-flex flex-column">
                  <Card.Title>Pro</Card.Title>
                  <Card.Text className="flex-grow-1">
                    <strong>100 RC (10€) offerts</strong>
                    <br /><strong>{proPlanPrice}</strong>
                    <br /> {proPlanBillingText}
                    <br />
                    <br /> Analyse pièce : 5 RC
                    <br /> Analyse complète : 50 RC
                    <br /> Rapport PDF commercial : 70 RC
                    <br /> IA avancée
                  </Card.Text>
                  <Button 
                    variant="primary"
                    onClick={() => navigate(`/signup?plan=pro&billing=${billingCycle}`)}
                    >
                    Choisir Pro
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            {/* Entreprise */}
            <Col md={4}>
              <Card className="text-center h-100 d-flex flex-column pricing-card">
                <Card.Body className="d-flex flex-column">
                  <Card.Title>Entreprise</Card.Title>
                  <Card.Text className="flex-grow-1">
                    <strong>Sur devis</strong>
                    <br />
                    <br />
                    Solution sur mesure pour vos besoins
                  </Card.Text>
                  <Button variant="secondary" onClick={() => navigate("/contact-entreprise")}>Nous Contacter</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <Container>
          <h2 className="section-title">Questions fréquentes</h2>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Comment fonctionne l'analyse par IA ?</Accordion.Header>
              <Accordion.Body>
                Notre intelligence artificielle a été entraînée sur des milliers de projets de rénovation. Elle analyse la structure, les matériaux visibles et les dimensions de vos pièces pour fournir une estimation des coûts de main-d'œuvre et de matériaux.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Les estimations sont-elles fiables ?</Accordion.Header>
              <Accordion.Body>
                Nos estimations sont conçues pour vous donner un ordre de grandeur fiable pour budgétiser vos projets. Elles sont basées sur les prix moyens du marché, mais peuvent varier en fonction des artisans, des matériaux choisis et de votre localisation.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Puis-je utiliser Renovestim en tant qu'artisan ?</Accordion.Header>
              <Accordion.Body>
                Oui ! Renovestim propose un annuaire pour les artisans. En vous inscrivant, vous gagnez en visibilité auprès de clients potentiels qui ont déjà un projet d'estimation et qui cherchent des professionnels qualifiés.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Container>
      </section>
    </div>
  );
};

export default LandingPage;
